import React from "react";
import {
  ImageSelectionGridPage as PageType,
  UserProfile,
} from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  userProfile: UserProfile;
  onAnswer: (value: string) => void;
}

const ImageSelectionGridPage: React.FC<Props> = ({ page, onAnswer }) => {
  const handleSelect = (value: string) => {
    console.log("Selected:", value);
    onAnswer(value);
  };

  return (
    <div className="page page--image-selection-grid">
      <div className="page__container">
        {/* Question */}
        <h2 className="page__question">{page.question}</h2>
        {page.subtitle && <p className="page__subtitle">{page.subtitle}</p>}

        {/* Options Grid */}
        <div className="image-grid">
          {page.options.map((option) => (
            <button
              key={option.id}
              className="image-grid__option"
              onClick={() => handleSelect(option.value)}
            >
              <div className="image-grid__image-wrapper">
                <img
                  src={option.image}
                  alt={option.label}
                  className="image-grid__image"
                />
              </div>
              <span className="image-grid__label">{option.label}</span>
            </button>
          ))}
        </div>

        {/* Footer */}
        {page.footer && (
          <footer className="page__footer">
            <p className="page__footer-text">
              {page.footer.disclaimerText}{" "}
              {page.footer.termsLink && (
                <a
                  href={page.footer.termsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="page__footer-link"
                >
                  {page.footer.termsText || "Terms of Service"}
                </a>
              )}
              {page.footer.privacyLink && (
                <>
                  {" | "}
                  <a
                    href={page.footer.privacyLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="page__footer-link"
                  >
                    {page.footer.privacyText || "Privacy Policy"}
                  </a>
                </>
              )}
            </p>
          </footer>
        )}
      </div>
    </div>
  );
};

export default ImageSelectionGridPage;
